import { render } from "./noticepost.vue?vue&type=template&id=434a4f7c"
import script from "./noticepost.vue?vue&type=script&lang=js"
export * from "./noticepost.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__